(function () {
  const SECTION_SELECTOR = ".c-product-content__tabs";
  const WRAP_SELECTOR =
    ".c-product-content__tabs .c-product-tabs__scroller-wrap";
  const SCROLLER_SELECTOR = ".tabs-nav__scroller";
  const NAV_SELECTOR = ".c-product-tabs__nav";
  const TAB_ITEM_SELECTOR = ".product-tabs__tab-item-wrapper";
  const SCROLL_THRESHOLD = 2;
  const MOBILE_MEDIA_QUERY = window.matchMedia("(max-width: 999px)");

  function updateFadeState(wrap) {
    const scroller = wrap.querySelector(SCROLLER_SELECTOR);
    if (!scroller) {
      return;
    }

    if (MOBILE_MEDIA_QUERY.matches) {
      wrap.classList.remove(
        "c-product-tabs__scroller-wrap--fade-start",
        "c-product-tabs__scroller-wrap--fade-end",
      );
      return;
    }

    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    const canScrollLeft = scroller.scrollLeft > SCROLL_THRESHOLD;
    const canScrollRight =
      maxScrollLeft > SCROLL_THRESHOLD &&
      scroller.scrollLeft < maxScrollLeft - SCROLL_THRESHOLD;

    wrap.classList.toggle(
      "c-product-tabs__scroller-wrap--fade-start",
      canScrollLeft,
    );
    wrap.classList.toggle(
      "c-product-tabs__scroller-wrap--fade-end",
      canScrollRight,
    );
  }

  function initWrap(wrap) {
    const scroller = wrap.querySelector(SCROLLER_SELECTOR);
    if (!scroller || wrap.dataset.cProductTabsInit === "true") {
      return;
    }

    wrap.dataset.cProductTabsInit = "true";

    const onUpdate = () => updateFadeState(wrap);

    scroller.addEventListener("scroll", onUpdate, { passive: true });
    window.addEventListener("resize", onUpdate);

    if (typeof ResizeObserver !== "undefined") {
      const resizeObserver = new ResizeObserver(onUpdate);
      resizeObserver.observe(scroller);
    }

    requestAnimationFrame(onUpdate);
    setTimeout(onUpdate, 100);
  }

  function syncSectionLayout(section) {
    const nav = section.querySelector(NAV_SELECTOR);
    const tabItems = Array.from(section.querySelectorAll(TAB_ITEM_SELECTOR));

    if (!nav || tabItems.length === 0) {
      return;
    }

    if (MOBILE_MEDIA_QUERY.matches) {
      tabItems.forEach((item) => {
        item.hidden = false;
      });
      return;
    }

    const tabButtons = Array.from(nav.querySelectorAll("button[aria-controls]"));
    const selectedButton =
      tabButtons.find(
        (button) => button.getAttribute("aria-expanded") === "true",
      ) || tabButtons[0];

    if (!selectedButton) {
      return;
    }

    const selectedItemId = selectedButton.getAttribute("aria-controls");
    tabItems.forEach((item) => {
      item.hidden = item.id !== selectedItemId;
    });
  }

  function syncAllLayouts(root) {
    root.querySelectorAll(SECTION_SELECTOR).forEach(syncSectionLayout);
  }

  function initAll(root) {
    root.querySelectorAll(WRAP_SELECTOR).forEach(initWrap);
    syncAllLayouts(root);
  }

  if (window.__lalineProductTabsInitialized) {
    initAll(document);
    return;
  }

  window.__lalineProductTabsInitialized = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  MOBILE_MEDIA_QUERY.addEventListener("change", () => {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();
